module.exports = __webpack_public_path__ + "img/四川天府新区元音中学.36fa15b2.jpg";